import React, { forwardRef } from 'react';
import { Icon } from '../Icon';
export const ChevronDownIcon = forwardRef(function ChevronDownIcon(props, ref) {
    return (React.createElement(Icon, { ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("path", { d: "M16.5 10L12 14.5L7.5 10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })));
});
